import { combine } from "effector"
import { useUnit } from "effector-react"

import userStore from "./user"
import tenantSettingsStore from "./tenantSettings"
import permissionsStore from "./permissions"
import unitsStore from "./units"
import interfaceStatusesStore from "./interfaceStatuses"
import { $tenantProfitCenters, $userProfitCenters, fetchTenantProfitCenters, fetchUserProfitCenters } from "./profitCenters"

const $common = combine(
    userStore.$user,
    tenantSettingsStore.$tenantSettings,
    tenantSettingsStore.$tenantSettingsLanguages,
    permissionsStore.$permissions,
    unitsStore.$units,
    interfaceStatusesStore.$interfaceStatuses,
    $tenantProfitCenters,
    $userProfitCenters,
    (user, tenantSettings, tenantSettingsLanguages, permissions, units, interfaceStatus, tenantProfitCenters, userProfitCenters) => {
        if (!user
            || !tenantSettings
            || !tenantSettingsLanguages
            || !permissions
            || units.length === 0
            || !interfaceStatus
            || !tenantProfitCenters
            || !userProfitCenters) return null
        return {
            user,
            tenantSettings,
            tenantSettingsLanguages,
            permissions,
            units,
            interfaceStatus,
        }
    }
);

export async function initCommonStore() {
    const user = await userStore.fetchUser()
    if (user) {
        await Promise.all([
            tenantSettingsStore.fetchTenantSettings(),
            tenantSettingsStore.fetchTenantSettingsLanguages(),
            tenantSettingsStore.fetchGlobalAssetOverview(),
            permissionsStore.initGlobalPermissions(),
            unitsStore.fetchUnits(),
            interfaceStatusesStore.fetchInterfaceStatuses(),
            fetchTenantProfitCenters(),
            fetchUserProfitCenters(),
        ])
    }
}

export function useCommonStore() {
    return useUnit($common)
}
